

export const saveStringAsFile = (content, fileName) => {
    let anchor = document.createElement("a");
    let file_obj = new Blob([content]);
    anchor.href = URL.createObjectURL(file_obj);
    anchor.download = fileName;
    anchor.click();
}